export default __webpack_public_path__ + "static/media/bloodfury.26196c61.png";